import { inject, Injectable } from "@angular/core";
import { ISystemRolesApiClient } from "./i-system-roles-api.client";
import { CollectionApiClient, ILookup, IPaginationParameters, IPaginationResponse } from "../../../../core";
import { UserManagementCollections } from "../../../common";
import { HttpClient } from "@angular/common/http";
import { Observable } from "rxjs";


@Injectable({
  providedIn: 'root'
})
export class SystemRolesApiClient implements ISystemRolesApiClient {
  public http = inject(HttpClient);
  private collectionApiClient = CollectionApiClient.create(UserManagementCollections.SystemRoles, this.http);

  get(
      paginationParameters?: IPaginationParameters
    ): Observable<IPaginationResponse<ILookup<string>>> {
      return this.collectionApiClient.get({
        paginationParameters
      });
    }
}